import {
  COMMON_SHOW_NOTIFICATION,
  ORDER_DERIVATIVES_MODIFY_ORDER,
  ACCOUNT_OTP_VERIFY_SUCCESS,
  GET_SIGN_TOKENCA,
} from 'redux/actions';
import { IAction, INotification, IResponse } from 'interfaces/common';
import {
  IDerivativesModifyOrderParams,
  IDerivativesModifyOrderResponse,
  ISignTokenCAResponse,
  ISaveSignTokenCAResponse,
} from 'interfaces/api';
import { IModifyOrderReducer } from 'interfaces/reducers';
import { OrderKind } from 'constants/enum';
import { ToastType } from 'react-toastify';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { query } from 'utils/socketApi';
import config from 'config';
import { IState } from 'redux/global-reducers';
import { signTokenCA, registerTokenCA } from '../../../../utils/signTokenCA';
import { addHours } from 'date-fns';

function modifyOrder(params: IDerivativesModifyOrderParams) {
  return query(config.apis.derivativesModifyOrder, params);
}

function* doModifyOrder(request: IAction<IDerivativesModifyOrderParams>) {
  const store: IState = yield select((state: IState) => ({
    signTokenCA: state.signTokenCA,
    otp: state.otp,
  }));

  if (request.payload.isNotChangeVal) {
    yield put<IAction<INotification>>({
      type: COMMON_SHOW_NOTIFICATION,
      payload: {
        type: ToastType.ERROR,
        title: 'Modify Order',
        content: 'Please change at least one correction order information',
        time: new Date(),
      },
    });
  } else {
    try {
      if (store.signTokenCA?.isTokenCA) {
        const data = {
          action: 'verifyTokenDerivativesModifyOrder',
          serialToken: store.signTokenCA?.serial,
          dataSign: {
            data: request.payload
          },
          timeSign: new Date(),
        };

        if (store.signTokenCA?.serial) {
          const responseSign: ISignTokenCAResponse = yield call(
            signTokenCA,
            store.signTokenCA?.serial,
            data
          );
          if (responseSign && responseSign.code == 1) {
            let dataSubmit = {
              dataSignTokenCA: responseSign.data,
              ...data,
            };

            const responseSaveSignTokenCA: ISaveSignTokenCAResponse = yield call(registerTokenCA, {
              action: 'verifyTokenDerivativesModifyOrder',
              serialToken: store.signTokenCA.serial ?? '',
              dataSign: JSON.stringify(dataSubmit),
              timeSign: addHours(new Date(), 7).toISOString() ?? '',
            });

            if (
              responseSaveSignTokenCA &&
              responseSaveSignTokenCA.status !== 201
            ) {
              yield put<IAction<INotification>>({
                type: COMMON_SHOW_NOTIFICATION,
                payload: {
                  type: ToastType.ERROR,
                  title: 'Modify Order',
                  content: 'MODIFY_ORDER_FAILED',
                  time: new Date(),
                },
              });
            } else {
              const response: IResponse<IDerivativesModifyOrderResponse> = yield call(
                modifyOrder,
                request.payload
              );

              if (request.response != null) {
                yield put<IAction<IModifyOrderReducer>>({
                  type: request.response.success,
                  payload: {
                    ...response.data,
                    orderKind: OrderKind.NORMAL_ORDER,
                  },
                });
              }

              yield put<IAction<INotification>>({
                type: COMMON_SHOW_NOTIFICATION,
                payload: {
                  type: ToastType.SUCCESS,
                  title: 'Modify Order',
                  content: 'MODIFY_ORDER_SUCCESS',
                  contentParams: { orderNumber: response?.data?.orderId },
                  time: new Date(),
                },
              });
            }
          }
        }
      } else {
        const response: IResponse<IDerivativesModifyOrderResponse> = yield call(
          modifyOrder,
          request.payload
        );

        if (request.response != null) {
          yield put<IAction<IModifyOrderReducer>>({
            type: request.response.success,
            payload: { ...response.data, orderKind: OrderKind.NORMAL_ORDER },
          });
        }

        yield put<IAction<INotification>>({
          type: COMMON_SHOW_NOTIFICATION,
          payload: {
            type: ToastType.SUCCESS,
            title: 'Modify Order',
            content: 'MODIFY_ORDER_SUCCESS',
            contentParams: { orderNumber: response?.data?.orderId },
            time: new Date(),
          },
        });
      }
    } catch (error) {
      if (request.response) {
        yield put<IAction<string>>({
          type: request.response.failed,
          payload: error.code || error.message,
        });
      }

      yield put<IAction<INotification>>({
        type: COMMON_SHOW_NOTIFICATION,
        payload: {
          type: ToastType.ERROR,
          title: 'Modify Order',
          content: error.code || error.message,
          contentParams: error.messageParams,
          time: new Date(),
        },
      });
    }
  }

  if (store.otp?.otpToken?.data?.expiryTime == 0) {
    yield put({
      type: ACCOUNT_OTP_VERIFY_SUCCESS,
      payload: {
        token: null,
      },
    });
  }

  yield put({
    type: GET_SIGN_TOKENCA,
    payload: {
      serial: '',
      isTokenCA: false,
    },
  });
}

export default function* watchModifyOrder() {
  yield takeLatest(ORDER_DERIVATIVES_MODIFY_ORDER, doModifyOrder);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/Order/Derivatives/ModifyOrder.ts